<template>
  <div class="mr-0 bg-gray-200 maincomponent-area overflow-y-auto">
    <div class="px-5 py-3">
      <router-link to="/users" class="text-sm text-gray-700 hove:text-gray-900">
        Hem / Användare
      </router-link>
      <h1 class="mt-3 font-sans text-xl leading-none font-medium text-gray-900 whitespace-no-wrap">
        {{ current.userName }}
      </h1>
    </div>

    <div class="mx-auto">
      <div class="flex items-justify bg-white">
        <tabs class="relative w-full" v-if="this.current.subject">
          <tab name="allmänt" :selected="true">
            <usergeneral />
          </tab>
          <tab name="roller" :selected="false">
            <userroles />
          </tab>
          <tab name="egenskaper" :selected="false">
            <userclaims />
          </tab>
        </tabs>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import UserGeneral from "./UserGeneral";
import UserRoles from "./UserRoles";
import UserClaims from "./UserClaims";
import Tabs from "@/components/Tabs";
import Tab from "@/components/Tab";

export default {
  name: "userdetails",
  components: {
    usergeneral: UserGeneral,
    userroles: UserRoles,
    userclaims: UserClaims,
    tabs: Tabs,
    tab: Tab
  },
  computed: {
    ...mapGetters("usersStore", ["current"])
  },
  methods: {
    ...mapActions("usersStore", ["fetch"])
  },
  async mounted() {
    await this.fetch(this.$route.params.id);
  }
};
</script>
